(() => {
  angular.module('finance').component('genericInvoiceDetailComponent', {
    templateUrl: require('./generic.component.html'),
    controller: GenericInvoiceDetailComponent,
    controllerAs: 'vm',
    bindings: {
      currencyCode: '<',
      invoice: '<',
      invoiceFrom: '<',
      invoiceTo: '<',
      isAddressInvoiceFrom: '<',
      isAddressInvoiceTo: '<',
      message: '<',
      getDateString: '<'
    },
  });

  GenericInvoiceDetailComponent.$inject = [];

  function GenericInvoiceDetailComponent() {
    const vm = this;

    vm.loading = 0;

    init();

    function init() {}
  }
})();
